import { TeamInvitationDTO } from "@shaarp/common";
import { TeamUserRolesEnum } from "@/enums/team-user-role";
import SelectPrice from "../pricing/select-price";

export default function DataTableCellUserInvitationLicence({
  invitation,
}: {
  invitation: TeamInvitationDTO;
}) {
  if (invitation.role === TeamUserRolesEnum.BILLING) {
    return null;
  }

  return <SelectPrice value={invitation.priceId || ""} disabled />;
}
